import React from "react";
import FacebookSharpIcon from '@mui/icons-material/FacebookSharp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import XIcon from '@mui/icons-material/X';

import 'styles/scora.css'

function Footer() {
  return (
    <footer className="scora_footer p-5 d-flex align-items-end">
      {/* <div className="col-12 align-self-end">©2025 Precision Services Group, All rights reserved.</div> */}
      <div className="fw-bold text-secondary-emphasis">Powered By | Precision Services Group</div>
    </footer>
  );
}

export default Footer;
